export default __webpack_public_path__ + "static/media/cave-front.e29c37a1.png";